// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"More_wrapper__BdNE7","menu":"More_menu__2XG5Z"};